import { type ExtraValues, type PlatformEvent } from '../types';

export const adIsViewedForTicketEvent = (extra: ExtraValues): PlatformEvent => {
  return {
    type: 'ad',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'view_for_ticket',
      ...extra.event_properties,
    },
  };
};
